export const SET_ACTIVE_FIELDS = "SET_ACTIVE_FIELDS";